import mongoose from 'mongoose'

export const subscribeRequestsSchema = mongoose.Schema({
    sender:{
        type:mongoose.Schema.Types.ObjectId,
        ref:"User",
        required:true
    },
    receiver:{
        type:mongoose.Schema.Types.ObjectId,
        ref:"User",
        required:true
    },
    wallet:{
        type:mongoose.Schema.Types.ObjectId,
        ref:"Wallet",
        required:true 
    },
    status:{
        type:String,
        default:"pending"
    }
},{collection:"subscribe_requests"});


export default mongoose.model("SubscribeRequest",subscribeRequestsSchema);
